import styled from "styled-components";

export const EventImageWrapper = styled.div`
  width: 5.375rem;
  height: 5.375rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
  background-color: #F5F5F5;
`;

export const EventImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const PlaceholderIcon = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 2rem;
    height: 2rem;
    color: #999;
  }
`;

export const EventDetailsWrapper = styled.div`
  flex: 1;
`;

export const EventInfo = styled.div`
  display: flex;
  align-items: center;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 0.75rem;
  line-height: normal;
  color: #555;
  margin-bottom: 0.25rem;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const Icon = styled.span`
  margin-right: 8px;
  display: flex;
  align-items: center;
  
  svg {
    width: 1rem;
    height: 1rem;
  }
`;

export const EventItem = styled.div`
  display: flex;
  align-items: flex-start;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.07);
  padding: 1rem;
  max-width: 100%;
  gap: 1rem;
`;

export const EventName = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 0.875rem;
  line-height: normal;
  color: #000000;
  margin-bottom: 0.5rem;
`;